import React, { createContext, useContext, useState, ReactNode } from "react";

export interface RegionContextType {
  selectedRegion: string | null;
  setSelectedRegion: (region: string | null) => void;
}

const RegionContext = createContext<RegionContextType | undefined>(undefined);

interface RegionProviderProps {
  children: ReactNode;
}

export const RegionProvider: React.FC<RegionProviderProps> = ({ children }) => {
  const [selectedRegion, setSelectedRegion] = useState<string | null>(null);

  const contextValue: RegionContextType = {
    selectedRegion,
    setSelectedRegion,
  };

  return (
    <RegionContext.Provider value={contextValue}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = (): RegionContextType => {
  const context = useContext(RegionContext);
  if (context === undefined) {
    throw new Error("useRegion must be used within a RegionProvider");
  }
  return context;
};
